import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { getAxiosInstance } from "@/axiosClient";

export const useReemplazosStore = defineStore("reemplazos", () => {
  // State
  const reemplazos = ref(null);
  const reemplazante = ref(null);

  // Getters
  const hasReemplazos = computed(() => {
    return reemplazos.value?.length > 0;
  });

  // Actions
  const setReemplazos = (value) => {
    reemplazos.value = value;
  };

  const setReemplazante = (value) => {
    reemplazante.value = value;
  };

  const fetchReemplazos = async ({ id }) => {
    try {
      const axios = getAxiosInstance();
      const response = await axios.get(`/api/reemplazos/${id}`);
      reemplazos.value = response.data;
    } catch (error) {
      console.error("Error fetching reemplazos:", error);
    }
  };

  const resetState = () => {
    reemplazos.value = null;
    reemplazante.value = null;
  };

  return {
    // State
    reemplazos,
    reemplazante,
    // Getters
    hasReemplazos,
    // Actions
    setReemplazos,
    setReemplazante,
    fetchReemplazos,
    resetState,
  };
});
